
import { Component, Vue } from "vue-property-decorator";
import api from "@/api";
import store from "@/store";
@Component({
  components: {},
})
export default class business extends Vue {
  // 字典
  config = store.state.system.config;
  d: any = {};

  loading = false;

  warrantee_qyzz: any = {}
  getData(data: any) {
    this.warrantee_qyzz = data[0]
    let str = this.warrantee_qyzz.filecode + '|' + this.warrantee_qyzz.name
    this.nonbid.warrantee_qyzz = str
  }
  del(idx: any) {
    this.$confirm('是否删除该项?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      this.warrantee_qyzz = {}
      this.nonbid.warrantee_qyzz = ''
    })
  }

  warrantee_yyzz: any = {}
  getData2(data: any) {
    this.warrantee_yyzz = data[0]
    let str = this.warrantee_yyzz.filecode + '|' + this.warrantee_yyzz.name
    this.nonbid.warrantee_yyzz = str
  }
  del2(idx: any) {
    this.$confirm('是否删除该项?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      this.warrantee_yyzz = {}
      this.nonbid.warrantee_yyzz = ''
    })
  }

  warrantee_frsfzm: any = {}
  getData3(data: any) {
    this.warrantee_frsfzm = data[0]
    let str = this.warrantee_frsfzm.filecode + '|' + this.warrantee_frsfzm.name
    this.nonbid.warrantee_frsfzm = str

  }
  del3(idx: any) {
    this.$confirm('是否删除该项?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      this.warrantee_frsfzm = {}
      this.nonbid.warrantee_frsfzm = ''
    })
  }

  warrantee_frsffm: any = {}
  getData4(data: any) {
    this.warrantee_frsffm = data[0]
    let str = this.warrantee_frsffm.filecode + '|' + this.warrantee_frsffm.name
    this.nonbid.warrantee_frsffm = str
  }
  del4(idx: any) {
    this.$confirm('是否删除该项?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      this.warrantee_frsffm = {}
      this.nonbid.warrantee_frsffm = ''
    })
  }

  warrantee_zbwj: any = {}
  getData5(data: any) {
    this.warrantee_zbwj = data[0]
    let str = this.warrantee_zbwj.filecode + '|' + this.warrantee_zbwj.name
    this.nonbid.warrantee_zbwj = str
  }
  del5(idx: any) {
    this.$confirm('是否删除该项?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      this.warrantee_zbwj = {}
      this.nonbid.warrantee_zbwj = ''
    })
  }

  warrantee_cb: any = {}
  getData6(data: any) {
    this.warrantee_cb = data[0]
    let str = this.warrantee_cb.filecode + '|' + this.warrantee_cb.name
    this.nonbid.warrantee_cb = str

  }
  del6(idx: any) {
    this.$confirm('是否删除该项?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      this.warrantee_cb = {}
      this.nonbid.warrantee_cb = ''
    })
  }

  warrantee_zbtzs: any = {}
  getData7(data: any) {
    this.warrantee_zbtzs = data[0]
    let str = this.warrantee_zbtzs.filecode + '|' + this.warrantee_zbtzs.name
    this.nonbid.warrantee_zbtzs = str
  }
  del7(idx: any) {
    this.$confirm('是否删除该项?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      this.warrantee_zbtzs = {}
      this.nonbid.warrantee_zbtzs = ''
    })
  }

  project_sght_file: any = {}
  getData8(data: any) {
    this.project_sght_file = data[0]
    let str = this.project_sght_file.filecode + '|' + this.project_sght_file.name
    this.nonbid.project_sght_file = str
  }
  del8(idx: any) {
    this.$confirm('是否删除该项?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      this.project_sght_file = {}
      this.nonbid.project_sght_file = ''
    })
  }



  // 变更业务信息
  change(type: any) {
    this.nonbid.only_safe = type == 1 ? 1 : 2
    this.nonbid.order_code = this.o.order_code
    this.nonbid.op_id = this.o.op_id
    this.nonbid.product_id = this.o.product_id
    this.nonbid.org_id = this.o.org_id
    this.nonbid.bond_type = this.o.bond_type
    this.nonbid.org_type = this.o.org_type
    this.nonbid.letter_money = this.o.letter_money
    this.nonbid.project_name = this.o.project_name
    this.nonbid.channel_id = this.o.channel_id
    this.nonbid.outorg_name = this.o.outorg_name
    this.nonbid.org_zj = this.o.org_zj
    this.nonbid.account_manager = this.o.account_manager
    this.nonbid.letter_type = this.o.letter_type
    // 被保证人所在地省市区
    if(this.casValue.length >0) {
      this.nonbid.warrantee_one = this.casValue[0]
      this.nonbid.warrantee_two = this.casValue[1]
      this.nonbid.warrantee_three = this.casValue[2]
    }


    // 删除字段
    delete this.nonbid.beneficiary_xydm
    delete this.nonbid.remark
    delete this.nonbid.audit_status
    delete this.nonbid.audit_node
    delete this.nonbid.audit_at
    delete this.nonbid.status
    delete this.nonbid.pay_status
    delete this.nonbid.sign_status
    delete this.nonbid.confirm_at
    delete this.nonbid.outorg_at
    delete this.nonbid.letter_at
    delete this.nonbid.sign_at
    delete this.nonbid.pay_at
    delete this.nonbid.created_at
    delete this.nonbid.updated_at
    delete this.nonbid.bond_type_text
    delete this.nonbid.org_type_text
    delete this.nonbid.pay_status_text;
    delete this.nonbid.status_text;
    delete this.nonbid.project_sjkgr;
    delete this.nonbid.outorg_apply_code;
    delete this.nonbid.outorg_letter_code;
    delete this.nonbid.coupon_or;
    delete this.nonbid.coupon_id;
    delete this.nonbid.coupon_type;
    delete this.nonbid.coupon_money;
    delete this.nonbid.coupon_mobile;
    delete this.nonbid.end_at;
    delete this.nonbid.letter_status;

    if(typeof this.nonbid.warrantee_qyzz == 'object') {
      let str = this.warrantee_qyzz.filecode + '|' + this.warrantee_qyzz.name
      this.nonbid.warrantee_qyzz = str
    }
    if(typeof this.nonbid.warrantee_yyzz == 'object') {
      let str = this.warrantee_yyzz.filecode + '|' + this.warrantee_yyzz.name
      this.nonbid.warrantee_yyzz = str

    }
    if(typeof this.nonbid.warrantee_frsfzm == 'object') {
      let str = this.warrantee_frsfzm.filecode + '|' + this.warrantee_frsfzm.name
      this.nonbid.warrantee_frsfzm = str

    }
    if(typeof this.nonbid.warrantee_frsffm == 'object') {
      let str = this.warrantee_frsffm.filecode + '|' + this.warrantee_frsffm.name
      this.nonbid.warrantee_frsffm = str
    }
    if(typeof this.nonbid.warrantee_zbwj == 'object') {
      let str = this.warrantee_zbwj.filecode + '|' + this.warrantee_zbwj.name
      this.nonbid.warrantee_zbwj = str
    }
    if(typeof this.nonbid.warrantee_cb == 'object') {
      let str = this.warrantee_cb.filecode + '|' + this.warrantee_cb.name
      this.nonbid.warrantee_cb = str
    }
    if(typeof this.nonbid.warrantee_zbtzs == 'object') {
      let str = this.warrantee_zbtzs.filecode + '|' + this.warrantee_zbtzs.name
      this.nonbid.warrantee_zbtzs = str
    }
    if(typeof this.nonbid.project_sght_file == 'object') {
      let str = this.project_sght_file.filecode + '|' + this.project_sght_file.name
      this.nonbid.project_sght_file = str
    }

    if(type == 2) {
      if(!this.paramsValidate()) {
        return
      }
    }

    api.post('A17006', this.nonbid).then(res => {
      this.$message.success('操作成功')
      this.getInfo()
    })
  }

  private nonbid: {
    [propName: string]: any;
  } = {
    order_code:"",
    op_id:"",
    channel_id:"",
    product_id:"",
    org_id:"",
    outorg_name:"",
    bond_type:"",
    org_type:"",
    org_zj_code:"",
    org_zj:"",
    manager_id:"",
    manager_mobile:"",
    account_manager:"",
    letter_money:"",
    letter_period_type:"",
    letter_period:"",
    start_at:"",
    letter_period_date:"",
    warrantee:"",
    warrantee_xycode:"",
    warrantee_one:"",
    warrantee_two:"",
    warrantee_three:"",
    warrantee_area:"",
    warrantee_address:"",
    warrantee_type:"",
    warrantee_jjxz:"",
    warrantee_zzdj:"",
    warrantee_lxr:"",
    warrantee_dh:"",
    warrantee_qyzz:"",
    warrantee_yyzz:"",
    warrantee_frsfzm:"",
    warrantee_frsffm:"",
    warrantee_zbwj:"",
    warrantee_cb:"",
    warrantee_zbtzs:"",
    beneficiary:"",
    beneficiary_xydm:"",
    project_name:"",
    project_jsxz:"",
    project_htbh:"",
    project_lx:"",
    project_gcqq:"",
    project_gczq:"",
    project_sght_file:""
  };


  private errors: {
    [propName: string]: any;
  } = {
    warrantee_one: '',
    warrantee_two: '',
    warrantee_three: ''

  };

  // 地区选择
  casValue: any = [];
  tag: any = -1; // 标识符（重要）
  changeQY2(item: any) {
    if(item.length == 0) {
      this.casValue = []
      this.tag = -1
      return
    }
    this.nonbid.warrantee_one = item[0].toString()
    this.nonbid.warrantee_two = item[1].toString()
    this.nonbid.warrantee_three = item[2].toString()
    let isGo = false;
    let _tag = 0;
    item.forEach((i: any) => {
      if (i[0] != this.tag) {
        isGo = true;
        _tag = i[0];
      }
    });
    if (isGo) {
      let filterd = item.filter((v: any) => v[0] != this.tag);
      this.tag = _tag;
      this.casValue = filterd;
    }
  }

  project_szd: any = []
  tag2: any = -1; // 标识符（重要）
  changeQY(item: any) {
    let isGo = false;
    let _tag = 0;
    item.forEach((i: any) => {
      if (i[0] != this.tag2) {
        isGo = true;
        _tag = i[0];
      }
    });
    if (isGo) {
      let filterd = item.filter((v: any) => v[0] != this.tag2);
      this.tag2 = _tag;
      this.project_szd = filterd;
    }
  }

  // 省市区
  qhdm = []
  getQhdm(org_code: any) {
    api.getQhdm({org_code: org_code}).then(res => {
      this.qhdm = res
    })
  }

  paramsValidate() {
    let nonbid = this.nonbid
    let obj: any = {
      start_at: nonbid.start_at,
      letter_period_date: nonbid.letter_period_date,
      warrantee: nonbid.warrantee,
      warrantee_one: nonbid.warrantee_one,
      warrantee_two: nonbid.warrantee_two,
      warrantee_three: nonbid.warrantee_three,
      warrantee_xycode: nonbid.warrantee_xycode,
      warrantee_address: nonbid.warrantee_address,
      warrantee_type: nonbid.warrantee_type,
      warrantee_jjxz: nonbid.warrantee_jjxz,
      warrantee_zzdj: nonbid.warrantee_zzdj,
      warrantee_qyzz: nonbid.warrantee_qyzz,
      warrantee_dh: nonbid.warrantee_dh,
      warrantee_yyzz: nonbid.warrantee_yyzz,
      warrantee_frsfzm: nonbid.warrantee_frsfzm,
      warrantee_frsffm: nonbid.warrantee_frsffm,
      warrantee_zbwj: nonbid.warrantee_zbwj,
      warrantee_cb: nonbid.warrantee_cb,
      warrantee_zbtzs: nonbid.warrantee_zbtzs,
      beneficiary: nonbid.beneficiary,
      project_name: nonbid.project_name,
      project_jsxz: nonbid.project_jsxz,
      project_htbh: nonbid.project_htbh,
      project_lx: nonbid.project_lx,
      project_gcqq: nonbid.project_gcqq,
      project_gczq: nonbid.project_gczq,
      project_sght_file: nonbid.project_sght_file
    }
    for(let key in obj) {
      if(!obj[key]) {
        this.$message.warning('页面所有内容为必填项')
        return false
      }
    }
    return true
  }

  // 录单
  btnloading = false
  ludan(type: any) {
    this.nonbid.only_safe = type == 1 ? 1 : 2
    this.nonbid.order_code = this.o.order_code

    // 被保证人所在地省市区
    if(this.casValue.length >0) {
      this.nonbid.warrantee_one = this.casValue[0]
      this.nonbid.warrantee_two = this.casValue[1]
      this.nonbid.warrantee_three = this.casValue[2]
    }

    if(type == 2) {
      if(!this.paramsValidate()) {
        return
      }
    }

    this.btnloading = true
    api.post('A17002', this.nonbid).then(res => {
      this.$message.success('操作成功')
      this.getInfo()
      this.$router.back()
    }).finally(() => {
      this.btnloading = false
    })
  }

  edit(type: any) {
    this.nonbid.only_safe = type == 1 ? 1 : 2
    // 被保证人所在地省市区
    if(this.casValue.length >0) {
      this.nonbid.warrantee_one = this.casValue[0]
      this.nonbid.warrantee_two = this.casValue[1]
      this.nonbid.warrantee_three = this.casValue[2]
    }
    // 删除字段
    delete this.nonbid.beneficiary_xydm
    delete this.nonbid.remark
    delete this.nonbid.audit_status
    delete this.nonbid.audit_node
    delete this.nonbid.audit_at
    delete this.nonbid.status
    delete this.nonbid.pay_status
    delete this.nonbid.sign_status
    delete this.nonbid.confirm_at
    delete this.nonbid.outorg_at
    delete this.nonbid.letter_at
    delete this.nonbid.sign_at
    delete this.nonbid.pay_at
    delete this.nonbid.created_at
    delete this.nonbid.updated_at
    delete this.nonbid.bond_type_text
    delete this.nonbid.org_type_text
    delete this.nonbid.pay_status_text;
    delete this.nonbid.status_text;
    delete this.nonbid.project_sjkgr;
    delete this.nonbid.outorg_apply_code;
    delete this.nonbid.outorg_letter_code;
    delete this.nonbid.coupon_or;
    delete this.nonbid.coupon_id;
    delete this.nonbid.coupon_type;
    delete this.nonbid.coupon_money;
    delete this.nonbid.coupon_mobile;
    delete this.nonbid.end_at;
    delete this.nonbid.letter_status;

    if(typeof this.nonbid.warrantee_qyzz == 'object') {
      let str = this.warrantee_qyzz.filecode + '|' + this.warrantee_qyzz.name
      this.nonbid.warrantee_qyzz = str
    }
    if(typeof this.nonbid.warrantee_yyzz == 'object') {
      let str = this.warrantee_yyzz.filecode + '|' + this.warrantee_yyzz.name
      this.nonbid.warrantee_yyzz = str

    }
    if(typeof this.nonbid.warrantee_frsfzm == 'object') {
      let str = this.warrantee_frsfzm.filecode + '|' + this.warrantee_frsfzm.name
      this.nonbid.warrantee_frsfzm = str

    }
    if(typeof this.nonbid.warrantee_frsffm == 'object') {
      let str = this.warrantee_frsffm.filecode + '|' + this.warrantee_frsffm.name
      this.nonbid.warrantee_frsffm = str
    }
    if(typeof this.nonbid.warrantee_zbwj == 'object') {
      let str = this.warrantee_zbwj.filecode + '|' + this.warrantee_zbwj.name
      this.nonbid.warrantee_zbwj = str
    }
    if(typeof this.nonbid.warrantee_cb == 'object') {
      let str = this.warrantee_cb.filecode + '|' + this.warrantee_cb.name
      this.nonbid.warrantee_cb = str
    }
    if(typeof this.nonbid.warrantee_zbtzs == 'object') {
      let str = this.warrantee_zbtzs.filecode + '|' + this.warrantee_zbtzs.name
      this.nonbid.warrantee_zbtzs = str
    }
    if(typeof this.nonbid.project_sght_file == 'object') {
      let str = this.project_sght_file.filecode + '|' + this.project_sght_file.name
      this.nonbid.project_sght_file = str
    }

    if(type == 2) {
      if(!this.paramsValidate()) {
        return
      }
    }

    this.nonbid.order_code = this.$route.query.code
    this.btnloading = true
    api.post('A17005', this.nonbid).then(res => {
      this.$message.success('操作成功')
      this.getInfo()
      this.$router.back()
    }).catch(err => {
      // 错误改用读取data.errors
      this.errors = err.message;
      // Object.assign(this.errors, data);
      this.$nextTick().then(() => {
        const first = this.$el.querySelector(
                '[has-error]:not([has-error=""])'
        ) as HTMLElement;
        if (first) {
          if (first.tagName === "LABEL") return first.focus();
          const last = [
            ...first.querySelectorAll("label"),
          ].pop() as HTMLElement;
          return last.focus();
        }

      });
    }).finally(() => {
      this.btnloading = false
    })
  }

  muban = {}
  getTplSection() {
    api.getTplSection({org_id: this.o.org_id, bond_type: this.o.bond_type}).then(res => {
      this.muban = res
    })
  }

  getInfo() {
    api
            .post("A17007", {order_code: this.$route.query.code})
            .then((data: any) => {
              this.o = data.order_info;
              this.nonbid.op_id = data.order_info.op_id
              this.nonbid.channel_id = data.order_info.channel_id
              this.nonbid.product_id = data.order_info.product_id
              this.nonbid.org_id = data.order_info.org_id
              this.nonbid.outorg_name = data.order_info.outorg_name
              this.nonbid.bond_type = data.order_info.bond_type
              this.nonbid.org_type = data.order_info.org_type
              this.nonbid.org_zj = data.order_info.org_zj
              this.nonbid.letter_money = data.order_info.letter_money
              this.nonbid.letter_period_type = data.order_info.letter_period_type
              this.nonbid.letter_period = data.order_info.letter_period
              this.nonbid.manager_id = data.order_info.manager_id
              this.nonbid.manager_mobile = data.order_info.manager_mobile
              this.nonbid.account_manager = data.order_info.account_manager
              this.nonbid.warrantee = data.order_info.warrantee
              this.nonbid.beneficiary = data.order_info.beneficiary
              this.nonbid.project_name = data.order_info.project_name
              this.nonbid.start_at = data.order_info.start_at
              this.nonbid.letter_period_date = data.order_info.letter_period_date
              this.nonbid.warrantee_dh = data.order_info.apply_mobile ? data.order_info.apply_mobile : ''

              this.getTplSection()
              if(JSON.stringify(data.apply_info) != "{}") {
                this.nonbid = {...this.nonbid, ...data.apply_info};
                // 省市区
                this.casValue = [this.nonbid.warrantee_one, this.nonbid.warrantee_two, this.nonbid.warrantee_three]
                // this.nonbid.warrantee_zgzz = this.nonbid.warrantee_zgzz == 0 ? '' : this.nonbid.warrantee_zgzz.toString()

                this.warrantee_yyzz = this.nonbid.warrantee_yyzz != '' ? this.nonbid.warrantee_yyzz : this.warrantee_yyzz
                this.warrantee_zbwj = this.nonbid.warrantee_zbwj != '' ? this.nonbid.warrantee_zbwj : this.warrantee_zbwj
                this.warrantee_cb = this.nonbid.warrantee_cb != '' ? this.nonbid.warrantee_cb : this.warrantee_cb
                this.warrantee_qyzz = this.nonbid.warrantee_qyzz != '' ? this.nonbid.warrantee_qyzz : this.warrantee_qyzz
                this.warrantee_zbtzs = this.nonbid.warrantee_zbtzs != '' ? this.nonbid.warrantee_zbtzs : this.warrantee_zbtzs
                this.warrantee_frsfzm = this.nonbid.warrantee_frsfzm != '' ? this.nonbid.warrantee_frsfzm : this.warrantee_frsfzm
                this.warrantee_frsffm = this.nonbid.warrantee_frsffm != '' ? this.nonbid.warrantee_frsffm : this.warrantee_frsffm
                this.project_sght_file = this.nonbid.project_sght_file != '' ? this.nonbid.project_sght_file : this.project_sght_file


              }


            })
            .finally(() => {
              this.loading = false;
            });
  }
  o: any = {}
  type = ''
  look = false
  activated() {
    api.getDics().then((res) => {
      store.dispatch("system/addConfig", res);
      this.config = store.state.system.config
    });
    this.getQhdm(this.$route.query.org_code)
    // this.loading = true;
    let {code , form, type, look } = this.$route.query
    this.look = false
    if(type) {
      this.type = type.toString()
    }
    if(look) {
      this.look = true
    }

    this.d = {};
    this.o = {}
    this.warrantee_qyzz = {}
    this.warrantee_yyzz = {}
    this.warrantee_frsfzm = {}
    this.warrantee_frsffm = {}
    this.warrantee_zbwj = {}
    this.warrantee_cb = {}
    this.warrantee_zbtzs = {}
    this.project_sght_file = {}
    this.nonbid = {
      order_code:"",
      op_id:"",
      channel_id:"",
      product_id:"",
      org_id:"",
      outorg_name:"",
      bond_type:"",
      org_type:"",
      org_zj_code:"",
      org_zj:"",
      manager_id:"",
      manager_mobile:"",
      account_manager:"",
      letter_money:"",
      letter_period_type:"",
      letter_period:"",
      start_at:"",
      letter_period_date:"",
      warrantee:"",
      warrantee_xycode:"",
      warrantee_one:"",
      warrantee_two:"",
      warrantee_three:"",
      warrantee_area:"",
      warrantee_address:"",
      warrantee_type:"",
      warrantee_jjxz:"",
      warrantee_zzdj:"",
      warrantee_lxr:"",
      warrantee_dh:"",
      warrantee_qyzz:"",
      warrantee_yyzz:"",
      warrantee_frsfzm:"",
      warrantee_frsffm:"",
      warrantee_zbwj:"",
      warrantee_cb:"",
      warrantee_zbtzs:"",
      beneficiary:"",
      beneficiary_xydm:"",
      project_name:"",
      project_jsxz:"",
      project_htbh:"",
      project_lx:"",
      project_gcqq:"",
      project_gczq:"",
      project_sght_file:""
    }
    this.casValue = []
    this.getInfo()
  }
}
